import { useMemo } from "react";

import { type Conversation } from "shared/apiClient";
import { type Noticeboard } from "shared/lib";

import { useGetReportContent } from "shared/hooks";

export type TreeModuleExpertResult = {
  measurement_method: "diameter" | "circumference" | "conflict";
  distance_above_ground_level: string;
  tree_height_trigger: string;
};

export function useTreeModuleExpertResult(
  conversation: Conversation | undefined | null,
  noticeboardData: Noticeboard | undefined | null,
) {
  const { getConfig } = useGetReportContent({
    conversation,
    noticeboardData,
  });

  return useMemo(() => {
    const { systemLanguageParsedOutput } = getConfig("enquiry.tree_module");

    return systemLanguageParsedOutput as TreeModuleExpertResult | undefined;
  }, [getConfig]);
}
